import { useAuth } from "../../../../Providers/AuthProvider"
import { useCompanyInfo } from "../../../../Providers/CompanyInfoProvider"
import WholeSalePricesSwitch from "../../../Components/WholeSalePricesSwitch"
import CustomerInformationMobile from "../../CustomerInformationMobile";
import useCommonFunctions from "../../../../Pages/Shop/Hooks/MobileAndDesktopCommon/useCommonFunctions";
import { useEffect } from "react";

const TopBarMobileOptions = ({ handleReDirect, setIsOptionsExpended, topBarOptionsRef, isOptionsExpended }) => {
    const { authState, logout } = useAuth()
    const { navBarItems, loadingData } = useCompanyInfo()
    const { getLoadingDataSkeleton, getSocialMediaIcons, generateUserInformation } = useCommonFunctions()

    useEffect(() => {
        if (isOptionsExpended) {
            document.body.style.overflow = 'hidden'
        }
        return () => {
            document.body.style.overflow = 'auto'
        }
    }, [isOptionsExpended])

    const isUserLogIn = authState?.user ? true : false

    const generateNavBarItems = () => {
        return navBarItems.flatMap((item, index) => {
            const elementsToRender = [
                <div key={index} className="element-pointer mt-3 mb-3 ms-3" style={{ borderBottom: 'solid 1px var(--mobile-bar-options-border-color)', borderWidth: '50%' }}>
                    <span className='element-pointer' onClick={() => handleReDirect(item.reDirectLink, item.isReDirectLinkDirectToEHandel)}>{item.name}</span>
                </div>
            ]

            // Jeśli bieżący element to "Produkty", dodajemy do naszej tablicy "Kontrahentów - brakuje w pasku nawigacji miejsca"
            if (item.name === 'Produkty' && authState.user && authState.user.isOperator) {
                elementsToRender.push(
                    <div key="contractors-link" className="element-pointer mt-3 mb-3 ms-3" style={{ borderBottom: 'solid 1px var(--mobile-bar-options-border-color)', borderWidth: '50%' }}>
                        <span className='element-pointer' onClick={() => handleReDirect('/Contractors', true)}>Kontrahenci</span>
                    </div>
                )
            }
            return elementsToRender
        })
    }

    const logOutFunc = () => {
        logout()
        setIsOptionsExpended(false)
    }

    return (
        <div className="container-fluid mobile-top-bar-options-holder" ref={topBarOptionsRef}>
            <div className="row" style={{ marginBottom: '120px' }}>
                <div className="row">
                    {loadingData ? getLoadingDataSkeleton(true) : generateNavBarItems()}
                    {isUserLogIn && <div className="element-pointer mt-3 mb-3 ms-3" style={{ borderBottom: 'solid 1px var(--mobile-bar-options-border-color)', borderWidth: '50%' }}>
                        <WholeSalePricesSwitch
                            isMobileView={true}
                        />
                    </div>}
                </div>
                <div className="row">
                    <div className="d-flex justify-content-evenly mt-2 mb-2">
                        {getSocialMediaIcons(handleReDirect, true)}
                    </div>
                </div>
            </div>
            <div className="row fixed-bottom ps-3 pe-3 pt-2 pb-2" style={{ backgroundColor: 'white', marginBottom: '60px' }}>
                <div className="row" style={{ color: 'black' }}>
                    <div className="mb-1" onMouseDown={(e) => e.stopPropagation()}>
                        <CustomerInformationMobile />
                    </div>
                </div>
                {isUserLogIn ? (<>
                    <div className="row">
                        <div className="col-12" style={{ color: 'black' }}>
                            {/* <CustomerInformationMobile /> */}
                            {generateUserInformation(true)}
                        </div>
                        <div className="col-12 d-flex justify-content-center mt-2">
                            <button className="btn-app-secondary" onClick={() => logOutFunc()}>Wyloguj</button>
                        </div>
                    </div>
                </>)
                    :
                    (<>
                        <div className="col-6 d-flex justify-content-center">
                            <button className="btn-app-primary" onClick={() => handleReDirect('/login', true)}>Zaloguj się</button>
                        </div>
                        <div className="col-6 d-flex justify-content-center">
                            <button className="btn-app-secondary" onClick={() => handleReDirect('/Registration', true)}>Załóż konto</button>
                        </div>
                    </>)}
            </div>
        </div>
    )
}

export default TopBarMobileOptions